import { useState } from "react";
import "./Search.css";
import "../constants";

const Search = (props) => {
  const { searchTerm, setSearchTerm, searchCount, setSearchCount } = props;

  const submitFn = (e) => {
    e.preventDefault();
    console.log(e.target.children[0].value);
    setSearchTerm(e.target.children[0].value);
    setSearchCount(searchCount + 1);
    e.target.children[0].value = "";
  };

  return (
    <header>
      <form id="form" onSubmit={submitFn}>
        <input type="text" placeholder="Search" id="search" class="search" />
      </form>
    </header>
  );
};

export default Search;
